import { useEffect, useState } from 'react'
import Link from 'next/link'
import Comments from './Comments'
import ShareOption from './ShareOption'
import AuthorView from './Author'

export default function BlogPost(props: any) {
  const [shareOption, setShareOption] = useState<any[]>([])
  const [imgOverlay, setImgOverlay] = useState(false)
  const [selectedImg, setSelectedImg] = useState('')
  const {
    title,
    id,
    content,
    featuredImg,
    publishDate,
    author,
    category,
    comments,
    tags,
    diff
  } = props

  const makeShareOption = () => {
    const urlWithSlug = window.location.href
    const share = [
      {
        label: 'mail',
        src: '/share/mail.png',

        href: `mailto:?subject=${title.rendered}&body=${urlWithSlug}`
      },
      {
        label: 'twitter',
        src: '/share/tw.png',

        href: `https://twitter.com/share?url=${urlWithSlug}`
      },
      {
        label: 'fb',

        src: '/share/fb.png',
        href: `https://facebook.com/sharer/sharer.php?u=${urlWithSlug}`
      },
      {
        label: 'linkdin',
        src: '/share/lk.png',

        href: `https://www.linkedin.com/shareArticle?mini=true&url=${urlWithSlug}`
      },
      {
        label: 'pintrest',
        src: '/share/pt.png',

        href: `https://pinterest.com/pin/create/bookmarklet/?&url=${urlWithSlug}`
      },
      {
        label: 'messenger',
        src: '/share/msn.png',

        href: `fb-messenger://share?link=${urlWithSlug}`
      }
    ]
    setShareOption(share)
  }

  useEffect(() => {
    makeShareOption()
  }, [props])

  const renderDate = () => {
    if (diff !== undefined) {
      if (diff.y === 0) {
        return `${parseInt(diff.m) + 1} months ago`
      } else {
        return `${diff.y} year ago`
      }
    }
  }
  const imgFull = e => {
    setSelectedImg(e.target.src)
    setImgOverlay(true)
  }

  const getYtId = yturl => {
    if (yturl) {
      var videoId = yturl.split('v=')[1]
      if (videoId !== undefined) {
        var ampersandPosition = videoId.indexOf('&')
        if (ampersandPosition !== -1) {
          videoId = videoId.substring(0, ampersandPosition)
        }
        return videoId
      } else if (yturl.split('/') !== undefined) {
        videoId = yturl.split('/')?.pop()
        return videoId
      } else {
      }
    }
  }

  const showYouTubeEmbed = () => {
    const wrapper = document.querySelector(
      '.wp-block-embed__wrapper'
    ) as HTMLElement
    if (wrapper) {
      const ytLink = document.querySelector('.wp-block-embed__wrapper')
        ?.innerHTML

      const el = document.createElement('div')
      el.innerHTML = `<iframe className="py-4" width="400" height="315" src="https://www.youtube.com/embed/${getYtId(
        ytLink
      )}"></iframe>`
      document
        .querySelector('.wp-block-embed__wrapper')
        ?.parentNode?.insertBefore(el, wrapper.nextSibling)
      wrapper.style.display = 'none'
    }
  }

  useEffect(() => {
    const youtubeEmbedd = document.querySelector('.wp-block-embed-youtube')

    if (youtubeEmbedd) {
      showYouTubeEmbed()
    }
  }, [])

  return (
    <>
      {imgOverlay && (
        <div className="overlay-z" onClick={() => setImgOverlay(false)}>
          <div className="flex justify-end">
            <button
              onClick={() => setImgOverlay(false)}
              className="self-center w-8 h-8 my-4 text-center bg-red-400 rounded-full focus:outline-none"
            >
              X
            </button>
          </div>

          <div className=" overlay-img-container">
            {featuredImg?.large && (
              <img
                loading="lazy"
                src={selectedImg}
                className="mb-3 rounded-md feature-img"
                alt={title.rendered}
              />
            )}
          </div>
        </div>
      )}

      <div>
        <div className="flex items-start justify-center mb-8 feature-img-container">
          {featuredImg?.large && (
            <img
              onClick={imgFull}
              loading="lazy"
              src={featuredImg.large}
              className="rounded-md feature-img"
              alt={title.rendered}
            />
          )}
        </div>
        <div className="flex flex-wrap mb-4 text-sm font-bold tracking-widest uppercase text-brand">
          {category?.length > 0 &&
            category.map(cat => (
              <Link key={cat.slug} href={`/blog/category/${cat.slug}`}>
                <a className="mb-2 mr-2 cursor-pointer">
                  <span dangerouslySetInnerHTML={{ __html: cat.cat_name }} />
                </a>
              </Link>
            ))}
        </div>

        <h1
          className="pt-0 mt-0 mb-2 text-4xl font-black tracking-tight md:text-4xl"
          dangerouslySetInnerHTML={{ __html: title.rendered }}
        />

        <div className="relative flex flex-col mb-8 lg:flex-row gap-4 md:gap-8">
          <div className="max-w-md my-4 text-xs text-gray-400 grid grid-cols-3 gap-4 md:text-lg">
            {author && <span className="mr-2">{author.name}</span>}
            {publishDate && <span className="text-center">{renderDate()}</span>}
            {comments?.length > 0 && (
              <div className="text-right">{comments.length} comments</div>
            )}
          </div>
        </div>
        <div className="flex flex-col items-center md:items-start lg:justify-between md:flex-row">
          <div className="sticky hidden md:block top-8">
            <ShareOption shareOption={shareOption} />
          </div>
          <div
            className="pb-8 prose prose-blue md:prose-xl"
            dangerouslySetInnerHTML={{ __html: content || '' }}
          />
        </div>
        <div className="flex justify-center mb-8 md:hidden share-bottom space-x-4">
          {shareOption?.map(sh => (
            <div
              key={sh.label}
              className="flex flex-row flex-wrap items-center justify-center w-12 h-12 text-xs rounded-full "
            >
              <a href={sh.href} target="_blank">
                {sh.src ? (
                  <img src={sh.src} className="object-contain w-12 h-12" />
                ) : (
                  sh.label
                )}
              </a>
            </div>
          ))}
        </div>
        {tags && (
          <div className="flex flex-wrap px-4 mb-8 space-x-2">
            <a className="flex items-center justify-center px-4 py-1 text-xs leading-none text-gray-200 uppercase bg-gray-700 rounded-full shadow">
              #tags
            </a>
            {tags.map(tag => (
              <Link key={tag.term_id} href={`/blog/tag/${tag.slug}`}>
                <a className="flex items-center justify-center px-4 py-1 text-xs uppercase rounded-full shadow">
                  #{tag.name}
                </a>
              </Link>
            ))}
          </div>
        )}
        {author && (
          <div className="mt-12 mb-12">
            <AuthorView author={author} />
          </div>
        )}
        {comments && (
          <Comments comments={comments} renderDate={renderDate} id={id} />
        )}
      </div>
    </>
  )
}
